<iframe
  *ngIf="media.videoUrl"
  [src]="media.videoUrl | safe: 'resourceUrl'"
  frameborder="0"
  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen
></iframe>
